<template>
  <div>
    <div id="data-list-list-view" class="data-list-container">
      <vs-table
        class="hide-table"
        :sst="true"
        stripe
        @sort="handleSort"
        max-items="20"
        noDataText="No se encontraron datos"
        :data="documentsData">

        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

          <div class="flex flex-wrap-reverse items-center data-list-btn-container">

            <!-- ADD NEW -->
            <div v-if="$acl.check('owner') || $acl.check('operator')" class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="submitNewDocument">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 float-left text-base text-primary">Nueva firma</span>
            </div>
          </div>
        </div>

        <div slot="header" class="flex flex-wrap-reverse items-center">
          <vs-chip>
            {{ getInitialItem + 1 }}-{{ getInitialItem + documentsData.length }} de {{ getTotalItems }}
          </vs-chip>
        </div>

        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between d-b-search">
          <div class="flex flex-wrap-reverse items-center data-list-btn-container ml-auto">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Nombre de documento" icon-no-border v-model="searchValue" @input="handleSearch" class="is-label-placeholder border-r-50 min-w-search" />
          </div>
        </div>

        <template slot="thead">
          <vs-th sort-key="sign_status">
            Estado
          </vs-th>
          <vs-th sort-key="file_name">
            Nombre
          </vs-th>
          <vs-th sort-key="created_at" class="date-table">
            Fecha
          </vs-th>
          <vs-th class="min-w-action">
            Acciones
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" @click.native="detailDocument = true; selectedUuid = tr.uuid" class="cursor-pointer">
            <vs-td :data="data[indextr]['sign_status']">
              <vs-chip color="warning" v-if="data[indextr]['sign_status'] === 1">Sin firmar</vs-chip>
              <vs-chip class="chip-primary" v-if="data[indextr]['sign_status'] === 2">Pendiente</vs-chip>
              <vs-chip color="success" v-if="data[indextr]['sign_status'] === 3">Firmado</vs-chip>
            </vs-td>

            <vs-td :data="data[indextr]['file_name']">
              {{data[indextr]['file_name']}}
            </vs-td>

            <vs-td :data="data[indextr]['created_at']">
              {{new Date(data[indextr]['created_at']).toLocaleString()}}
            </vs-td>

            <vs-td class="min-w-action" @click.native.stop>
              <download-drop-down :document="tr"></download-drop-down>

              <vx-tooltip v-if="(tr.sign_status === 1 || tr.sign_status === 2) && tr.signatures.filter(signature => signature.attributes.email === user.me.email).length && tr.signatures.filter(signature => signature.attributes.email === user.me.email)[0].attributes.sign_status === 'PENDING'" text="Firmar documento" position="top" class="d-inline-block">
                <feather-icon icon="Edit2Icon" svgClasses="position-list w-5 h-5 text-primary stroke-current mr-3 sm:mt-2" @click="linkToSign(tr)" />
              </vx-tooltip>
              <vx-tooltip text="Ver detalles del documento" position="top" class="d-inline-block">
                <feather-icon icon="SlidersIcon" svgClasses="position-list w-5 h-5 hover:text-primary stroke-current mr-3 sm:mt-2" @click="detailDocument = true; selectedUuid = data[indextr]['uuid']" />
              </vx-tooltip>
              <vx-tooltip v-if="tr['sign_status'] !== 3" text="Eliminar" position="top" class="d-inline-block">
                <feather-icon  icon="TrashIcon" svgClasses="position-list w-5 h-5 hover:text-primary stroke-current sm:mt-2" @click="deleteDocument(tr)"/>
              </vx-tooltip>

            </vs-td>

          </vs-tr>
        </template>
      </vs-table>

      <vs-table
        class="show-table hidden"
        sst="true"
        stripe
        @sort="handleSort"
        max-items="20"
        noDataText="No se encontraron datos"
        :data="documentsData">

        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

          <div class="flex flex-wrap-reverse items-center data-list-btn-container">

            <!-- ADD NEW -->
            <div v-if="$acl.check('owner') || $acl.check('operator')" class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="submitNewDocument">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 float-left text-base text-primary">Nueva firma</span>
            </div>
          </div>
        </div>

        <div slot="header" class="flex flex-wrap-reverse items-center">
          <vs-chip>
            {{ getInitialItem + 1 }}-{{ getInitialItem + documentsData.length }} de {{ getTotalItems }}
          </vs-chip>
        </div>

        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between d-b-search">
          <div class="flex flex-wrap-reverse items-center data-list-btn-container ml-auto">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Nombre de documento" icon-no-border v-model="searchValue" @input="handleSearch" class="is-label-placeholder border-r-50 min-w-search" />
          </div>
        </div>

        <template slot="thead">
          <vs-th>Pendientes de firma</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" @click.native="detailDocument = true; selectedUuid = tr.uuid" class="cursor-pointer">
            <vs-td class="py-3 px-0">
              <table>
                <tbody class="no-shadow">
                <tr>
                  <td class="font-w-600">Estado</td>
                  <td :data="data[indextr]['sign_status']">
                    <vs-chip color="warning" v-if="data[indextr]['sign_status'] === 1">Sin firmar</vs-chip>
                    <vs-chip class="chip-primary" v-if="data[indextr]['sign_status'] === 2">Pendiente</vs-chip>
                    <vs-chip color="success" v-if="data[indextr]['sign_status'] === 3">Firmado</vs-chip>
                  </td>
                </tr>
                <tr>
                  <td class="font-w-600">Nombre</td>
                  <td class="brakeall" :data="data[indextr]['file_name']">
                    {{data[indextr]['file_name']}}
                  </td>
                </tr>
                <tr>
                  <td class="font-w-600">Fecha</td>
                  <td :data="data[indextr]['created_at']">
                    {{new Date(data[indextr]['created_at']).toLocaleString()}}
                  </td>
                </tr>
                <tr>
                  <td class="font-w-600">Acciones</td>
                  <td @click.stop>
                    <download-drop-down :document="tr"></download-drop-down>

                    <vx-tooltip v-if="(tr.sign_status === 1 || tr.sign_status === 2) && tr.signatures.filter(signature => signature.attributes.email === user.me.email)[0].attributes.sign_status === 'PENDING'" text="Firmar documento" position="top" class="d-inline-block">
                      <feather-icon icon="Edit2Icon" svgClasses="position-list w-5 h-5 hover:text-primary stroke-current mr-3 sm:mt-2" @click="linkToSign(tr)" />
                    </vx-tooltip>
                    <feather-icon icon="SlidersIcon" svgClasses="position-list w-5 h-5 hover:text-primary stroke-current mr-3 sm:mt-2" @click="detailDocument = true; selectedUuid = data[indextr]['uuid']" />
                    <feather-icon v-if="tr['sign_status'] !== 3" icon="TrashIcon" svgClasses="position-list w-5 h-5 hover:text-primary stroke-current sm:mt-2" @click="deleteDocument(tr)"/>

                  </td>
                </tr>
                </tbody>
              </table>
            </vs-td>


          </vs-tr>
        </template>

      </vs-table>

      <br>
      <vs-pagination :total="getTotalPages" v-model="currentPage" :max="5" @input="handleChangePage"></vs-pagination>
    </div>

    <vs-popup title="Detalle del documento" :active.sync="detailDocument">
      <detail-document v-if="detailDocument" :uuid="selectedUuid" :close-popup="closePopup"></detail-document>
    </vs-popup>

    <vs-popup class="signed_method"  title="Selecciona un Método de Firmado" :active.sync="signedMethodPopupEnable">
      <sign-selector :open-sign-position-popup="openSignPositionPopup" :submit-new-document="submitNewDocument"></sign-selector>
      <vs-popup title="Selecciona la posición de la firma" :active.sync="signPositionPopupEnable">
        <sign-position-selector :set-sign-position="setSignPosition" :submit-new-document="submitNewDocument"></sign-position-selector>
      </vs-popup>
    </vs-popup>

  </div>
</template>

<script>
import moment from "moment";
import DetailDocument from "../components/DetailDocument";
import {mapState} from "vuex";
import router from "../../../../router";
import SignSelector from "../components/SignSelector";
import SignPositionSelector from "../components/SignPositionSelector";
import DownloadDropDown from "../components/DownloadDropDown";

export default {
  name: "PartialDocumentsList",
  components: {
    DetailDocument,
    SignSelector,
    SignPositionSelector,
    DownloadDropDown
  },
  data: () => ({
    detailDocument: false,
    currentPage: 1,
    selectedUuid: '',
    searching: '',
    sort: {
      key: null,
      active: null
    },
    signedMethodPopupEnable: false,
    signPositionPopupEnable: false,
    signPositionRadio: 'NONE',
    timer: null,
    searchValue: ""
  }),
  computed: {
    ...mapState({
      user: function (state) {
        return state.account.user;
      },
    }),
    documentsData() {
      return this.$store.state.document.documentsPending.data;
    },
    getTotalPages() {
      return this.$store.state.document.documentsPending.pagination.total
    },
    getInitialItem() {
      return this.$store.state.document.documentsPending.pagination.initialItem;
    },
    getTotalItems() {
      return this.$store.state.document.documentsPending.pagination.totalItems;
    },
    getDate() {
      return moment().format("Y-m-dTH:i:sP.");
    },
    selectedCompany() {
      return this.$store.state.account.user.me.selected_company.id;
    }
  },
  methods: {
    setSignPosition(signPosition) {
      this.signPositionRadio = signPosition;
    },
    openSignPositionPopup() {
      this.signPositionPopupEnable = true;
    },
    submitNewDocument() {
      let request = {
        signMode: 'PDF_SIGNATURE',
        signPosition: this.signPositionRadio,
        company_id: this.selectedCompany
      }
      this.signPositionPopupEnable = false;
      this.signedMethodPopupEnable = false;
      setTimeout(function (){
        router.push({name: 'create-document', params: request});
      }, 100)
    },
    closePopup() {
      this.detailDocument = false;
    },
    linkToSign(tr) {
      router.push('/sign-document/' + tr.signatures.filter(signature => signature.attributes.email === this.user.me.email)[0].id)
    },
    downloadXml(uuid) {
      this.$store.dispatch("document/downloadXml", {uuid: uuid})
    },
    downloadPdfOriginal(uuid) {
      this.$store.dispatch("document/downloadPdfOriginal", {uuid: uuid})
    },
    downloadPdf(uuid) {
      this.$store.dispatch("document/downloadPdf", {uuid: uuid})
    },
    handleSearch(searching) {
      this.searching = searching;
      if (this.sort.active === 'desc') {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null
        }
        this.timer = setTimeout(() => {
          this.$store.dispatch('document/getPartialAll', {company_id: this.selectedCompany, page: this.currentPage - 1, search: searching, sort: "-" + this.sort.key}).catch(err => { console.error(err) })
        }, 1000)
      } else if (this.sort.active === 'asc') {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null
        }
        this.timer = setTimeout(() => {
          this.$store.dispatch('document/getPartialAll', {company_id: this.selectedCompany, page: this.currentPage - 1, search: searching, sort: this.sort.key}).catch(err => { console.error(err) })
        }, 1000)
      } else {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null
        }
        this.timer = setTimeout(() => {
          this.$store.dispatch('document/getPartialAll', {company_id: this.selectedCompany, page: this.currentPage - 1, search: searching}).catch(err => { console.error(err) })
        }, 1000)
      }
    },
    handleChangePage(page) {
      this.currentPage = page;
      if (this.sort.active === 'desc') {
        this.$store.dispatch('document/getPartialAll', {company_id: this.selectedCompany, page: page  - 1, search: this.searching, sort: "-" + this.sort.key}).catch(err => { console.error(err) })
      } else if (this.sort.active === 'asc') {
        this.$store.dispatch('document/getPartialAll', {company_id: this.selectedCompany, page: page  - 1, search: this.searching, sort: this.sort.key}).catch(err => { console.error(err) })
      } else {
        this.$store.dispatch('document/getPartialAll', {company_id: this.selectedCompany, page: page  - 1, search: this.searching}).catch(err => { console.error(err) })
      }
    },
    handleSort(key, active) {
      this.sort = {key, active};
      if (active === 'desc') {
        this.$store.dispatch('document/getPartialAll', {company_id: this.selectedCompany, page: this.currentPage  - 1, search: this.searching, sort: "-" + key}).catch(err => { console.error(err) })
      } else if (active === 'asc') {
        this.$store.dispatch('document/getPartialAll', {company_id: this.selectedCompany, page: this.currentPage  - 1, search: this.searching, sort: key}).catch(err => { console.error(err) })
      } else {
        this.$store.dispatch('document/getPartialAll', {company_id: this.selectedCompany, page: this.currentPage  - 1, search: this.searching}).catch(err => { console.error(err) })
      }
    },
    deleteDocument(document) {
      let instance = this;
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: '¿Estás seguro?',
        text: '¿Estás seguro de eliminar este documento?',
        acceptText: "Si",
        cancelText: "No",
        accept: function () {
          instance.$store.dispatch("document/deleteDocument", {document: document, aclChangeRole: this.$acl.change})
            .then(
              () => {
                instance.$store.dispatch('document/getPartialAll', {company_id: instance.selectedCompany, page: instance.currentPage - 1}).catch(err => { console.error(err) })
              }
            )
        }
      });
    }
  },
  created() {
    this.$store.dispatch('document/getPartialAll', {company_id: this.selectedCompany, page: this.currentPage  - 1}).catch(err => { console.error(err) })
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/custom/documentListResponsive.scss";

#data-list-list-view {

  .name-w{
    width: 25%;
  }
  .mail-w{
    width: 25%;
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
        box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
        cursor: pointer;
        td{
          padding: 20px;
          &:first-child{
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }
          &:last-child{
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
        }
        td.td-check{
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
